import { animate, style, transition, trigger } from '@angular/animations';
import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ASSETS_MENU, getTicketsTableData, MODALS, ROUTES, TICKET_SORT_COLUMNS, TICKETS_MENU } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { ModalService } from 'libs/common/src/lib/service/modal.service';
@Component({
  selector: 'app-asset-team-dashboard-personal',
  templateUrl: './asset-team-dashboard-personal.component.html',
  styleUrls: ['./asset-team-dashboard-personal.component.scss'],
  animations: [
    trigger('basicAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AssetTeamDashboardPersonalComponent implements OnInit {
  ticketStatus = TICKETS_MENU;
  assetStatus = ASSETS_MENU;
  showComponent: boolean = false;
  alertBox: any;
  snackBarConfig: any;
  tableDetails: any;
  loaderView: boolean = false;
  tableConfig = [
    {
      title: 'Ticket no.',
      hasMultiKeys: true,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        isTicket: true,
        keys: [
          {
            key: 'ticketNumber',
            from: 'ticket',
            handleAction: (ticketId: string) => {
              this.navigateToTicket(ticketId);
            },
          },
          { key: 'title', from: 'ticket' },
        ],
      },
    },
    {
      title: 'Asset tag',
      hasMultiKeys: true,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        isAssetTag: true,
        keys: [
          { key: 'assetCode', from: 'asset' },
          { key: 'name', from: 'asset' },
        ],
      },
    },
    {
      title: 'Status',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: [{ key: 'status', from: 'ticket', isStatus: true }],
        isTicket: true,
      },
    },
    {
      title: 'Asset name',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: { key: 'name', from: 'asset' },
        isAsset: true,
      },
    },
    {
      title: 'Ticket date',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: { key: 'createdAt', from: 'ticket', isDate: true },
        isTicket: true,
      },
    },
  ];
  sortDigit = 'DESC';
  currentPageNumber = '1';
  ticketStatusClicked: boolean = true;
  status: string = '';
  pageSize: string = '5';
  currentParams: any;
  count!: number;
  filterOptions = [
    { title: 'Ongoing', value: 'ONGOING' },
    { title: 'To-Do', value: 'TO_DO' },
    { title: 'On-Hold', value: 'ON_HOLD' },
    { title: 'Closed', value: 'CLOSED' },
    { title: 'All Tickets', value: '' },
  ];
  constructor(
    private modalService: ModalService,
    private commonHttpService: CommonHttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
  ) { }
  ngOnInit(): void {
    this.getUserTickets();
  }

  triggerModal(modal: string) {
    if (modal === MODALS.RAISE_TICKET_MODAL) {
      this.modalService.triggerModal(modal)?.subscribe((result) => {
        if (result) this.showAlertModal(result, 'raise_issue');
      });
    } else if (modal === MODALS.REQUEST_ASSET_MODAL) {
      this.modalService.triggerModal(modal)?.subscribe((result) => {
        if (result) this.showAlertModal(result, 'request_an_asset');
      });
    } else if (modal === MODALS.ACCESS_INSTALLATION_MODAL) {
      this.modalService.triggerModal(modal)?.subscribe((result) => {
        if (result) this.showAlertModal(result, 'access_installation');
      });
    }
  }

  showAlertModal(alertModalConfig: any, from: string) {
    if (from === 'raise_issue') {
      this.snackBarConfig = alertModalConfig;
      this.alertBox = true;
    } else if (from === 'request_an_asset') {
      this.snackBarConfig = alertModalConfig;
      this.alertBox = true;
    } else if (from === 'access_installation') {
      this.snackBarConfig = alertModalConfig;
      this.alertBox = true;
    }
  }

  handleSortAction(col: string) {
    const param = {
      sortColumn: '',
      sortDirection: this.sortDigit,
      pageNumber: this.currentPageNumber,
    };
    const iconConfig = this.tableConfig.filter(
      (response: any) => response.title === col
    );
    iconConfig[0].icon = this.sortDigit === 'ASC' ? 'sort-asc' : 'sort-desc';
    switch (col) {
      case 'Ticket no.':
        param.sortColumn = TICKET_SORT_COLUMNS.TICKET_NUMBER;
        break;
      case 'Asset Code':
        param.sortColumn = TICKET_SORT_COLUMNS.ASSET_CODE;
        break;
      case 'Status':
        param.sortColumn = TICKET_SORT_COLUMNS.TICKET_STATUS;
        break;
      case 'Asset name':
        param.sortColumn = TICKET_SORT_COLUMNS.ASSET_NAME;
        break;
      case 'Ticket date':
        param.sortColumn = TICKET_SORT_COLUMNS.TICKET_DATE;
        break;
      default:
        param.sortColumn = '';
        break;
    }
    this.getUserTickets(param);
  }

  navigateToTicket(ticketId: string) {
    this.ticketStatusClicked = false;
    this.router.navigate([ROUTES.USER_TICKET_DETAILS + ticketId]);
  }

  getUserTickets(param?: any) {
    this.loaderView = true;
    const params = {
      status: this.status || '',
      pageNumber: param?.pageNumber || '1',
      itemsPerPage: this.pageSize || '5',
      sortColumn: param?.sortColumn || '',
      sortDirection: param?.sortDirection || '',
    };
    this.currentParams = params;
    const loadRequest = this.commonHttpService.getAllTicketsForUser(params);
    if (loadRequest) {
      loadRequest.subscribe({
        next: (response) => {
          const ticketsData = Object(response).data;
          // this.tableDetails = ticketsData.tickets;
          this.tableDetails = getTicketsTableData(ticketsData.tickets);
          this.count = ticketsData.count;
          this.commonService.searchParam.next({
            sortColumn: param?.sortColumn,
            sortDirection: param?.sortDirection,
            pageNumber: param?.pageNumber,
          });
          this.loaderView = false;
        },
        error: () => {
          this.loaderView = false;
        },
      });
      this.currentPageNumber = param?.pageNumber;
      this.sortDigit = this.sortDigit === 'DESC' ? 'ASC' : 'DESC';
      this.changeDetectorRef.detectChanges();
    }
  }

  filterBy(filter: string) {
    this.status = filter;
    this.getUserTickets();
  }
  pageSizeChange(pageSize: string) {
    this.pageSize = pageSize;
    this.getUserTickets();
  }
}
